import styled from "styled-components";

export const OportunityContainer = styled.section`
  height: 70vh;
  display: flex;
`;

export const LeftSection = styled.div`
  height: 100%;
  width: 15%;
  min-width: 200px;
  background-color: #104467;
  padding: 20px;
`;

export const ToggleViewButton = styled.div`
  width: 100%;
  height: 40px;
  border-radius: 3px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  background-color: ${(props) => (props.disabled ? "#dfdfdf" : "white")};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};

  span {
    color: #104467;
    font-weight: 500;
  }
`;

export const FiltersSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  gap: 10px;

  label {
    color: white;
    align-self: flex-start;
    margin-bottom: 5px;
  }
`;

export const CardsSection = styled.div`
  flex: 1;
  background-color: white;
  padding: 20px;
  row-gap: 30px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: auto;
  justify-items: center;
  align-items: center;
  overflow-y: auto;

  @media (max-width: 1120px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 800px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const AddingSection = styled.div`
  width: 100%;
  background-color: white;
  padding: 20px;
  justify-items: center;
  align-items: center;
  overflow: auto;
`;

export const Form = styled.form`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 20px;

  label {
    font-size: 0.9rem;
    margin-bottom: 3px;
    color: #104467;
    align-self: flex-start;
    text-align: left;
  }

  input {
    height: 50px;
    padding: 0 10px;
    border-radius: 4px;
    border: 1px solid rgba(16, 68, 103, 0.34);
  }

  textarea {
    height: 150px;
    padding: 5px 10px;
    border-radius: 4px;
    border: 1px solid rgba(16, 68, 103, 0.34);
  }

  .erro {
    color: red;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    font-size: 15px;
    align-self: start;
  }
`;

export const InputRow = styled.div`
  display: flex;
  width: 100%;
  gap: 20px;
  height: fit-content;
`;

export const InputRowSubmit = styled.div`
  display: flex;
  width: 100%;
  justify-content: end;
  align-items: center;
  gap: 20px;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  text-align: center;
`;

export const InputContainerCargo = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 400px;
  text-align: center;
  width: 60%;
`;

export const InputContainerDate = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 20%;
`;

export const InputContainerHalf = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 50%;
`;

export const SubmitButton = styled.div`
  align-self: flex-end;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 50px;
  background-color: ${(props) => (props.disabled ? "#f2f2f2" : "#104467")};
  border-radius: 3px;
  color: white;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
`;

export const WarningInputMessage = styled.span`
  color: red;
  font-size: 13px;

  &:hover {
    cursor: default;
  }
`;

export const OportunityCard = styled.div`
  background-color: #f2f2f2;
  width: 250px;
  border-radius: 5px;
  padding: 20px;
`;

export const IconContainer = styled.div`
  background-color: blanchedalmond;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: fit-content;

  &:hover {
    cursor: pointer;
  }
`;

export const HighlightSpan = styled.span`
  color: white;
  font-size: 0.75rem;

  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;
